import { Button } from '@mui/material'
import { removeTeam } from 'api/teams'
import { useAuthContext } from 'components/context/AuthProvider'
import ConfirmModal from 'components/modals/ConfirmModal'
import NotificationSys from 'components/NotificationSystem'
import { useShowControl } from 'hooks/useShowControl'
import React, { useCallback } from 'react'
import { useMutation } from 'react-query'
import { useTeams } from '../../hooks/useTeams'

export function TimelineTeamControlRemove() {
  const { isSharingEnabled } = useAuthContext()
  const {
    activeTeamId,
    checkIsDefault,
    checkIsSystemManaged,
    onChangeTeamToDefault,
    onRefetchTeams,
  } = useTeams()

  const isDefaultTeam = checkIsDefault(activeTeamId)
  const isSystemManagedTeam = checkIsSystemManaged(activeTeamId)

  const [isOpenConfirmRemove, onOpenConfirmRemove, onCloseConfirmRemove] = useShowControl()

  const removeTeamMutation = useMutation(removeTeam, {
    onSuccess: () => {
      onChangeTeamToDefault()
      onRefetchTeams()
      onCloseConfirmRemove()
      NotificationSys.showSuccess('Team removed successfully')
    },
  })

  const handleRemoveTeam = useCallback(() => {
    if (activeTeamId === null) return

    removeTeamMutation.mutate({
      id: activeTeamId,
    })
  }, [removeTeamMutation, activeTeamId])

  return (
    <>
      <Button
        variant="contained"
        disabled={
          activeTeamId === null || isDefaultTeam || isSystemManagedTeam || !isSharingEnabled
        }
        onClick={onOpenConfirmRemove}
      >
        Remove Team
      </Button>

      {isOpenConfirmRemove && (
        <ConfirmModal
          title="Confirm Team Removal"
          body="Are you sure you want to remove this team?"
          handleClose={onCloseConfirmRemove}
          handleConfirm={handleRemoveTeam}
          loading={removeTeamMutation.isLoading}
        />
      )}
    </>
  )
}
